/**
 * @generated SignedSource<<ae6c0cd0e6b2ccebe266c857fe0c5bfd>>
 * @relayHash 1d98f028d17ad9f621bdfdae3f304d7b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4d1c7df039b34325b1be8894b47edfe979cd0fcb6539236903815bb381b9b21d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useInlineHighlightsQuery$variables = {
  pageId: string;
};
export type useInlineHighlightsQuery$data = {
  readonly comments: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly location: {
        readonly inlineMarkerRef?: string | null | undefined;
        readonly type: string;
      };
      readonly replies: ReadonlyArray<{
        readonly id: string;
      } | null | undefined>;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useInlineHighlightsQuery = {
  response: useInlineHighlightsQuery$data;
  variables: useInlineHighlightsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "depth",
    "value": "ROOT"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  },
  {
    "kind": "Variable",
    "name": "pageId",
    "variableName": "pageId"
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "UNRESOLVED"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "type"
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineMarkerRef"
    }
  ],
  "type": "InlineComment"
},
v5 = {
  "concreteType": "Comment",
  "kind": "LinkedField",
  "name": "replies",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useInlineHighlightsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useInlineHighlightsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedCommentList",
        "kind": "LinkedField",
        "name": "comments",
        "plural": false,
        "selections": [
          {
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              },
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1d98f028d17ad9f621bdfdae3f304d7b",
    "id": "4d1c7df039b34325b1be8894b47edfe979cd0fcb6539236903815bb381b9b21d",
    "metadata": {},
    "name": "useInlineHighlightsQuery",
    "operationKind": "query",
    "text": "query useInlineHighlightsQuery($pageId:ID!){comments(pageId:$pageId,type:UNRESOLVED,depth:ROOT,first:1000){nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef}},replies{id}}}}"
  }
};
})();

(node as any).hash = "2fb3b51eea98e2fd2a940548824e472b";

export default node;
